import React, { ReactNode, useEffect, useRef } from "react"
import { ChevronRight, ChevronLeft } from "react-feather"
import Slider from "react-slick"
import "./slick-overrides.module.css"

type ArrowProps = {
  className?: string
  style?: object
  onClick?: () => void
}

type CarouselProps = {
  settingsOverrides?: object
  children: ReactNode
}

const NextArrow = ({ className, style, onClick }: ArrowProps) => {
  return (
    <div className={className} style={{ ...style }} onClick={onClick}>
      <ChevronRight />
    </div>
  )
}

const PrevArrow = ({ className, style, onClick }: ArrowProps) => {
  return (
    <div className={className} style={{ ...style }} onClick={onClick}>
      <ChevronLeft />
    </div>
  )
}

export const Carousel = ({ settingsOverrides, children }: CarouselProps) => {
  const sliderRef = useRef<any>(null)
  const containerRef = useRef<HTMLDivElement>(null)
  const lastScrollTime = useRef(0)

  useEffect(() => {
    const el = containerRef.current
    if (!el) return

    const handleWheel = (e: WheelEvent) => {
      const isHorizontal = Math.abs(e.deltaX) > Math.abs(e.deltaY)
      if (!isHorizontal) return

      e.preventDefault()

      const now = Date.now()
      if (now - lastScrollTime.current < 500) return
      lastScrollTime.current = now

      if (e.deltaX > 0) {
        sliderRef.current?.slickNext()
      } else {
        sliderRef.current?.slickPrev()
      }
    }

    el.addEventListener("wheel", handleWheel, { passive: false })
    return () => el.removeEventListener("wheel", handleWheel)
  }, [])

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToScroll: 1,
    slidesToShow: 2.5,
    swipeToSlide: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    ...settingsOverrides,
  }

  return (
    <div ref={containerRef}>
      <Slider ref={sliderRef} {...settings}>{children}</Slider>
    </div>
  )
}
